<div class="home-container" *ngIf="isReady">
    <section class="section-one">
        <div class="background-image position-relative">
            <img class="home-banner d-none d-sm-block" src="../../assets/homepage/images/home-banner.png" alt="A table set with red wine glasses, wine bottles, and fresh grapes in a luxurious setting with purple accents." title="Luxurious Wine Table with Grapes and Bottles">
            <img class="home-banner d-sm-none" src="../../assets/homepage/images/home-banner-mobile.png" alt="A table set with red wine glasses, wine bottles, and fresh grapes in a luxurious setting with purple accents." title="Luxurious Wine Table with Grapes and Bottles">
            <div class="w-100 h-100 position-absolute banner-shade"></div>
            <!-- <div class="beta-tag">
                <img class="" src="../../assets/homepage/images/beta-banner.png"  title="Beta Version Tag">
            </div> -->
        </div>
        <div class="banner-text w-100 text-center">
            <h1 class="heading mb-3">
                {{ 'home.discover' | translate }}. {{ 'home.connect' | translate }}. {{ 'home.trade' | translate }}.
                <br>
                <i>{{ 'home.banner_title' | translate }}</i>
            </h1>
            <div class="d-flex justify-content-center">
                <p class="description mb-4">{{ 'home.banner_desc' | translate }}</p>
            </div>
            <div class="text-center">
                <button type="button" class="btn tr-btn-primary btn-banner" routerLink="/registration">{{ 'home.banner_sign_up' | translate }}</button>
                <button type="button" class="btn btn-banner btn-how-works" routerLink="/home" fragment="how-works">{{ 'home.how_it_works' | translate }}</button>
            </div>
        </div>
        <div class="wines-container-border-0 container">
            <div class="wines-container-border d-flex justify-content-center">
                <div class="wines-container">
                    <div class="search-bar text-center">
                        <span class="position-relative">
                            <input type="text" name="search-bar" id="" placeholder="{{ 'home.search_text' | translate }}" [(ngModel)]="searchedText" [formControl]="searchControl">
                            <img src="../../assets/icons/search_bar_icon.svg" alt="search bar" srcset="" class="position-absolute">
                        </span>
                    </div>
                    <div class="loader" *ngIf="isLoading">
                        <div class="spinner"></div>
                        <p></p>
                    </div>
                    <div class="wines-cards row" *ngIf="!isLoading">
                        <div class="col-12 col-lg-6 col-xxl-4 mb-3 d-flex" *ngFor="let wine of wineList$ | async">
                            <div class="card-background d-flex flex-column w-100 h-100">
                                <div class="wine-card d-flex h-100">
                                    <div class="wine-image text-center user-wine-images" *ngIf="!showWineImages">
                                        <carousel [isAnimated]="true">
                                            <slide *ngFor="let img of wineImages$ | async | wineImage:wine.user_wine_id" >
                                                <img [src]="img" class="img-fluid" alt="wine">
                                            </slide>
                                        </carousel>
                                    </div>
                                    <div class="wine-image text-center user-wine-images" *ngIf="showWineImages">
                                        <carousel [isAnimated]="true">
                                            <slide *ngFor="let img of wineImages$ | async | wineImage:wine.user_wine_id" >
                                                <img [src]="img" class="img-fluid" alt="wine">
                                            </slide>
                                        </carousel>
                                    </div>
                                    <div class="wine-details d-flex flex-column">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="shadow-box text-center shadow-box-ask-price">
                                                <p class="ask-price-title text-uppercase font-bold m-0">
                                                    {{ 'marketplace.ask_price' | translate }}
                                                    <!-- <span class="" *ngIf="wine.user.userType == 'Business User'"
                                                        tooltip="{{ 'marketplace.offer_business_info' | translate }}" placement="auto">
                                                        <mat-icon aria-hidden="false" fontIcon="info"></mat-icon>
                                                    </span> -->
                                                </p>
                                                <div class="font-bold ask-price">{{ wine.so_ask_price  | currency:wine.cw_currency:'symbol':'.2-2':langCode }}</div>
                                            </div>
                                            <div class="distance-location d-flex align-items-center justify-content-center">
                                                <div class="mr-1 address text-center" *ngIf="wine.addressInfo">
                                                    <span>{{ wine.addressInfo | parseAddress:['city', 'country'] }}, </span>
                                                    <span class="fi" [ngClass]="'fi-'+(wine.addressInfo | parseAddress:['country'])?.toLowerCase()"></span>
                                                    <!-- <span class="font-bold distance" *ngIf="wine.distance"> {{ wine.distance == '501' ? '500>' : wine.distance }} km</span> -->
                                                    <!-- <span class="font-bold distance" *ngIf="!wine?.distance"> 500> kms</span> -->
                                                </div>
                                                <!-- <div class="mr-1 address text-right w-100" *ngIf="!wine.user.address">
                                                    <span class="font-bold distance" *ngIf="wine.distance"> {{ wine.distance == '501' ? '500>' : wine.distance }} km</span>
                                                    <span class="font-bold distance" *ngIf="!wine.distance"> 500> kms</span>
                                                </div> -->
                                            </div>
                                            <div class="date">{{ wine.so_updt_date }}</div>
                                        </div>
                                        <div class="wine-name">
                                            <h4 class="m-0 wine-name-responsive-72" *ngIf="wine?.wine_name.length > 72 && wine?.wine_name.length <= 95; else longName">{{ wine?.wine_name }}</h4>
                                            
                                            <ng-template  #longName>
                                                <h4 class="m-0" *ngIf="wine?.wine_name.length <= 72">{{ wine?.wine_name }}</h4>
                                                <h4 class="m-0" *ngIf="wine?.wine_name.length > 95" [tooltip]="wine?.wine_name">{{ wine?.wine_name | slice:0:60 }}...</h4>
                                            </ng-template>

                                            <div class="description d-flex" *ngIf="wine?.cw_description">
                                                <span class="text" [ngClass]="{'webkit-line-2': wine?.wine_name.length < 64}">{{ wine?.cw_description }}</span>
                                                <span class="more" (click)="showAllDescription(wine?.cw_description)" *ngIf="wine?.cw_description.length > 50">{{ 'marketplace.more' | translate }}</span>
                                            </div>
                                        </div>
                                        <div class="wine-info d-flex">
                                            <div class="left-side">
                                                <div>
                                                    <span class="field-label">{{ 'marketplace.wine_type' | translate }}</span><br>
                                                    <strong class="text-capitalize field-value" *ngIf="wine.so_wine_type">{{ 'code.' + wine.so_wine_type | translate }}</strong>
                                                </div>
                                                <div *ngIf="wine?.producer_name && wine?.producer_name.toLowerCase() != 'unknown' && wine?.producer_name != ''">
                                                    <span class="field-label">{{ 'marketplace.producer' | translate }}</span><br>
                                                    <strong class="text-capitalize field-value">{{ wine?.producer_title }} <span *ngIf="wine?.producer_title && wine?.producer_name"> by </span>{{ wine?.producer_name }}</strong>
                                                </div>
                                                <div>
                                                    <span class="field-label">{{ 'marketplace.sub_region' | translate }}, {{ 'marketplace.country' | translate }}</span><br>
                                                    <strong class="field-value">
                                                        <!-- <span>{{ wine.cellar_wine.global_wine.location }}</span>
                                                        <span *ngIf="wine.cellar_wine.global_wine.location && wine.cellar_wine.global_wine.region">, </span>
                                                        <span>{{ wine.cellar_wine.global_wine.region }}</span>
                                                        <span *ngIf="wine.cellar_wine.global_wine.region && wine.cellar_wine.global_wine.sub_region">, </span> -->
                                                        <span class="text-capitalize" *ngIf="wine.region">{{ wine.region }}</span>
                                                        <span *ngIf="wine.region && wine.country">, </span>
                                                        <span class="text-capitalize">{{ wine.country | countryName:langCode }}</span>
                                                    </strong>
                                                </div>
                                                <!-- Commented below div for TRES-719 -->
                                                <!-- <div *ngIf="wine.cellar_wine.global_wine?.current_price?.average">
                                                    <span>{{ 'marketplace.market_price' | translate }}: </span>
                                                    <strong class="text-capitalize">{{ wine.cellar_wine.global_wine?.current_price?.average | currency:'EUR':'symbol':'.2-2':langCode }}</strong>
                                                </div> --> 
                                            </div>
                                            <div class="right-side">
                                                <div *ngIf="wine.so_vintage">
                                                    <span class="field-label">{{ 'marketplace.vintage' | translate }}</span><br>
                                                    <strong class="text-capitalize field-value">{{ wine.so_vintage }}</strong>
                                                </div>
                                                <div *ngIf="wine.so_quantity">
                                                    <span class="field-label">{{ 'marketplace.quantity' | translate }}</span><br>
                                                    <strong class="text-capitalize field-value">{{ wine.so_quantity }}</strong>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-right btn-div mt-auto">
                                            <button type="button" class="btn tr-btn-primary" routerLink="/registration">{{ 'marketplace.start_bid' | translate }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-100 text-center mb-3" *ngIf="visibleCount < wineOffers.length && !onSearch">
                            <button type="button" class="btn tr-btn-secondary" (click)="loadMore()" >{{ 'home.load_more' | translate }}</button>
                        </div>
                        <div class="w-100 text-center mb-3" *ngIf="visibleCount < wineSlides.length && onSearch">
                            <button type="button" class="btn tr-btn-secondary" (click)="loadMoreOnSearch()" >{{ 'home.load_more' | translate }}</button>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
        <div class="key-points container">
            <div class="row text-center"> 
                <div class="col-12 col-md-6 col-lg-3 border-line-0">
                    <span>
                        <img  class="key-feature-img" src="../../assets/homepage/images/no_middleman.png" alt="no middleman" srcset="">
                    </span>
                    <h6 [innerHTML]="( 'home.key_feature_no_middleman' | translate )"></h6>
                    <p [innerHTML]="( 'home.key_feature_no_middleman_text' | translate )"></p>
                </div>
                <div class="col-12 col-md-6 col-lg-3 border-line-1">
                    <span>
                        <img  class="key-feature-img" src="../../assets/homepage/images/bidding.png" alt="bidding" srcset="">
                    </span>
                    <h6 [innerHTML]="( 'home.key_feature_bidding' | translate )"></h6>
                    <p [innerHTML]="( 'home.key_feature_bidding_text' | translate )"></p>
                </div>
                <div class="col-12 col-md-6 col-lg-3 border-line-2">
                    <span>
                        <img  class="key-feature-img" src="../../assets/homepage/images/verified_seller.png" alt="verified seller" srcset="">
                    </span>
                    <h6 [innerHTML]="( 'home.key_feature_verified_seller' | translate )"></h6>
                    <p [innerHTML]="( 'home.key_feature_verified_seller_text' | translate )"></p>
                </div>
                <div class="col-12 col-md-6 col-lg-3">
                    <span>
                        <img  class="key-feature-img" src="../../assets/homepage/images/transparent_listing.png" alt="transparent listing" srcset="">
                    </span>
                    <h6 [innerHTML]="( 'home.key_feature_transparent_listings' | translate )"></h6>
                    <p [innerHTML]="( 'home.key_feature_transparent_listings_text' | translate )"></p>
                </div>
            </div>
        </div>
    </section>
    <section class="section-six">
        <div class="digital-cellarbook container">
            <div class="digital-cellarbook-content">
                <p class="title">{{ 'home.cellarbook_content_title' | translate }}</p>
                <p class="about">{{ 'home.cellarbook_content_about' | translate }}</p>
                <p class="guides">{{ 'home.cellarbook_content_guide' | translate }}</p>
                <ul class="steps">
                    <li>{{ 'home.cellarbook_content_steps_1' | translate }}</li>
                    <li>{{ 'home.cellarbook_content_steps_2' | translate }}</li>
                    <li>{{ 'home.cellarbook_content_steps_3' | translate }}</li>
                    <li>{{ 'home.cellarbook_content_steps_4' | translate }}</li>
                    <li>{{ 'home.cellarbook_content_steps_5' | translate }}</li>
                </ul>
                <button type="button" class="btn tr-btn-primary" routerLink="/registration">{{ 'home.get_start' | translate }}</button>
            </div>
        </div>
        <div class="cellarbook-view" [ngClass]="{'mt-mb-for-de': langCode == 'DE'}">
            <div>
                <span class="header">
                    <img src="../../assets/homepage/images/digital-cellarbook-header.png" alt="Digital Cellarbook" srcset="">
                </span>
                <div class="cards">
                    <div class="d-flex">
                        <span>
                            <img src="../../assets/homepage/images/wine_card.png" alt="Demo wine card" srcset="">
                        </span>
                        <span>
                            <img src="../../assets/homepage/images/wine_card.png" alt="Demo wine card" srcset="">
                        </span>
                    </div>
                    <div class="d-flex">
                        <span>
                            <img src="../../assets/homepage/images/wine_card.png" alt="Demo wine card" srcset="">
                        </span>
                        <span>
                            <img src="../../assets/homepage/images/wine_card.png" alt="Demo wine card" srcset="">
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="section-six section-six-additional" id="community">
        <div class="community-banner scroll-section" >
            <div class="container d-flex flex-column flex-md-row">
                <div class="left-side">
                    <img class="star" src="../../assets/img/level-star.svg" alt="level star image">
                    <h2>{{ 'home.community_banner_title' | translate }}</h2>
                    <p class="text-one secondary-color">{{ 'home.community_banner_desc' | translate }}</p>
                    <div class="divider-line"></div>
                    <div class="text-two">{{ 'home.community_banner_question' | translate }} <br><span class="secondary-color"> {{ 'home.community_banner_answer' | translate }}</span></div>
                    <button class="btn tr-btn-primary" routerLink="/registration">{{ 'home.get_start' | translate }}</button>
                </div>
                <div class="right-side">
                    <img class="image-two d-block d-md-none" src="../../assets/homepage/images/community-two.png" alt="community members drinking wine">
                    <img class="image-one" src="../../assets/homepage/images/community-one.png" alt="community members drinking wine">
                    <img class="image-two d-none d-md-block" src="../../assets/homepage/images/community-two.png" alt="community members drinking wine">
                </div>
            </div>
            <div class="lower-rectangle">
                <img src="../../assets/homepage/images/community-rectangle.png" alt="rectangle">
            </div>
        </div>
    </section>
    <section class="section-six section-six-additional" id="how-works">
        <div class="how-works">
            <div class="container">
                <div class="text-center">
                    <p class="title">{{ 'home.how_work_title' | translate }}</p>
                    <p class="info" [innerHTML]="( 'home.how_work_info' | translate )"></p>
                </div>
                <div class="row stickers">
                    <div class="col-12 col-lg-6 col-xxl-4 mb-3">
                        <div class="sticker">
                            <div class="left-side">
                                <p>{{ 'home.how_work_signup' | translate }}</p>
                                <p>{{ 'home.how_work_signup_text' | translate }}</p>
                            </div>
                            <div class="right-side">
                                <span>
                                    <img src="../../assets/homepage/images/profile_frame.svg" alt="" srcset="">
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 col-xxl-4 mb-3">
                        <div class="sticker">
                            <div class="left-side">
                                <p>{{ 'home.how_work_cellarbook' | translate }}</p>
                                <p>{{ 'home.how_work_cellarbook_text' | translate }}</p>
                            </div>
                            <div class="right-side">
                                <span>
                                    <img src="../../assets/homepage/images/cellerbook_icon.svg" alt="" srcset="">
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 col-xxl-4 mb-3">
                        <div class="sticker">
                            <div class="left-side">
                                <p>{{ 'home.how_work_marketplace' | translate }}</p>
                                <p>{{ 'home.how_work_marketplace_text' | translate }}</p>
                            </div>
                            <div class="right-side">
                                <span>
                                    <img src="../../assets/homepage/images/trade_market.svg" alt="" srcset="">
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 col-xxl-4 mb-3">
                        <div class="sticker">
                            <div class="left-side">
                                <p>{{ 'home.how_work_vc' | translate }}</p>
                                <p>{{ 'home.how_work_vc_text' | translate }}</p>
                            </div>
                            <div class="right-side">
                                <span>
                                    <img src="../../assets/homepage/images/vino_coin.svg" alt="" srcset="">
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center bottom">
                    <p>{{ 'home.how_work_question' | translate }}</p>
                    <p>{{ 'home.how_work_join_now' | translate }}</p>
                    <button type="button" class="btn tr-btn-secondary" routerLink="/registration">{{ 'home.get_start' | translate }}</button>
                </div>
            </div>
        </div>
    </section>
    <!-- <section class="section-two" *ngIf="wineSlides.length > 9">
        <div class="wine-slider-container container">
            <h4 class="heading primary-color">{{ 'home.section_two_title' | translate }}</h4>
            <p class="description">{{ 'home.section_two_desc' | translate }}</p>
            <carousel [itemsPerSlide]="itemsPerSlide" [showIndicators]="false" [interval]="0" [singleSlideOffset]="true" *ngIf="showCarousel">
                <slide *ngFor="let slide of wineSlides;">
                    <div class="wine-slide">
                        <div class="card-background">
                            <div class="wine-image">
                                <img [src]="slide.wineImage" alt="wine bottle image">
                            </div>
                            <div class="wine-details">
                                <span class="wine-name primary-color">{{ slide.wine_name }}</span>
                                <div>
                                    <span>{{ 'home.'+slide.type | translate }}</span><br>
                                    <span *ngIf="slide.vintage">{{ 'home.vintage' | translate }}: {{ slide.vintage }}</span><br>
                                    <span *ngIf="slide.region">{{ slide.region }}</span><span *ngIf="slide.region && slide.country">, </span><span *ngIf="slide.country">{{ slide.country.toUpperCase() }}, <span class="fi" [ngClass]="'fi-'+slide.country.toLowerCase()"></span></span><br>
                                    <span *ngIf="slide.so_ask_price">{{ slide.so_ask_price | currency:'EUR':'symbol':'.2-2':langCode }}</span>
                                    <span class="wine-description">{{ slide.description }}</span>
                                </div>
                                <div class="button-container">
                                    <button type="button" class="btn tr-btn-primary" routerLink="/login">{{ 'home.buy_now' | translate }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </slide>
            </carousel>
        </div>
    </section> -->
    <!-- <section class="section-three scroll-section" id="how-it-works">
        <div class="container">
            <h2 class="primary-color font-bold m-0">{{ 'home.section_three_title' | translate }}</h2>
            <img class="desktop-gif d-none d-md-block" src="../../assets/homepage/at-a-glance/at-a-glance-desktop.gif" alt="Visual diagram showing a user interacting with features like the Cellar Book, Dashboard, Marketplace, and Community, connected to Vino Coins for completing tasks, leveling up, and viewing bids and market prices." title="User Workflow and Earning Vino Coins on TresorVino">
            <img class="mobile-gif d-md-none" src="../../assets/homepage/at-a-glance/at-a-glance-mobile.gif" alt="Visual diagram showing a user interacting with features like the Cellar Book, Dashboard, Marketplace, and Community, connected to Vino Coins for completing tasks, leveling up, and viewing bids and market prices." title="User Workflow and Earning Vino Coins on TresorVino">
        </div>
    </section> -->
    <section class="section-four">
        <div class="container">
            <div class="video-container text-center">
                <div class="position-relative video">
                    <img src="../../assets/homepage/at-a-glance/at-a-glance-desktop.gif" alt="Explainer"  [style.display]="isVideoPlaying ? 'none' : 'block'"/>
                    <video id="home-video" preload="auto" controlsList="nodownload" muted controls *ngIf="langCode === 'EN'"  [style.display]="!isVideoPlaying ? 'none' : 'block'">
                        <source src="../../assets/homepage/video/Tresorvino-Explainer-Video-EN.mp4" type="video/mp4">
                    </video>
                    <video id="home-video" preload="auto" controlsList="nodownload" muted controls *ngIf="langCode === 'DE'"  [style.display]="!isVideoPlaying ? 'none' : 'block'">
                        <source src="../../assets/homepage/video/Tresorvino-Explainer-Video-DE.mp4" type="video/mp4">
                    </video>
                    <!-- <div class="pause-overlay" *ngIf="!isVideoPlaying"></div> -->
                    <!-- <button type="button" class="play-pause-button" (click)="togglePlayPause()" *ngIf="!isVideoPlaying">
                        <img class="play-icon" src="../../assets/icons/play-icon.png">
                    </button> -->
                </div>
                <!-- <h4 class="mt-4">{{ 'home.section_four_video_title' | translate }}</h4>
                <p>{{ 'home.section_four_video_desc' | translate }}</p> -->
                <button type="button" class="btn tr-btn-primary mt-4" (click)="togglePlayPause()" *ngIf="!isVideoPlaying">{{ 'home.play_video' | translate }} <img src="../../assets/homepage/images/play_pause_icon.svg" alt="" srcset=""></button>
                <button type="button" class="btn tr-btn-primary mt-4" (click)="togglePlayPause()" *ngIf="isVideoPlaying">{{ 'home.pause_video' | translate }} <img src="../../assets/homepage/images/play_pause_icon.svg" alt="" srcset=""></button>
            </div>
        </div>
    </section>
    <section class="section-five scroll-section" id="features">
        <div class="container position-relative">
            <h2 class="primary-color heading">{{ 'home.why_tresorvino' | translate }}</h2>
            <p class="description">{{ 'home.section_five_desc' | translate }}</p>
            <div class="position-relative">
                <div class="features-container">
                    <div class="feature">
                        <div class="feature-info" id="ft-dashboard">
                            <h3 class="feature-title">{{ 'home.feature_1_title' | translate }}</h3>
                            <p class="feature-description">{{ 'home.feature_1_desc' | translate }}</p>
                        </div>
                        <div class="feature-video">
                            <ng-lottie class="d-md-none" [options]="dashboardMobileOptions"></ng-lottie>
                            <!-- <div class="sticky-container">
                                <ng-lottie class="d-none d-md-block" [options]="dashboardDeskOptions" width="400"></ng-lottie>
                                <img class="d-none d-md-block" src="../../assets/homepage/dashboard/dashboard-desktop.gif" alt="A dashboard showing the performance of all wine cellar books, including investment value, current value, total return, and a visual donut chart of wine types." title="Performance Overview of All Wine Cellar Books">
                                <img class="d-md-none" src="../../assets/homepage/dashboard/dashboard-mobile.gif" alt="A dashboard showing the performance of all wine cellar books, including investment value, current value, total return, and a visual donut chart of wine types." title="Performance Overview of All Wine Cellar Books">
                            </div> -->
                        </div>
                    </div>
                    <div class="feature">
                        <div class="feature-info" id="ft-vino">
                            <h3 class="feature-title">{{ 'home.feature_2_title' | translate }}</h3>
                            <p class="feature-description">{{ 'home.feature_2_desc' | translate }}</p>
                        </div>
                        <div class="feature-video">
                            <ng-lottie class="d-md-none" [options]="vinoMobileOptions"></ng-lottie>
                            <!-- <div class="sticky-container">
                                <ng-lottie class="d-none d-md-block" [options]="vinoDeskOptions" width="400"></ng-lottie>
                                <img class="d-none d-md-block" src="../../assets/homepage/vino-coins/vino-coins-desktop.gif" alt="Interface showing an option to unlock bids with 30 Vino Coins, alongside tasks like adding wines to the Cellar Book, buying from the marketplace, and posting wines to earn more Vino Coins." title="Unlock Bids and Earn Vino Coins on TresorVino">
                                <img class="d-md-none" src="../../assets/homepage/vino-coins/vino-coins-mobile.gif" alt="Interface showing an option to unlock bids with 30 Vino Coins, alongside tasks like adding wines to the Cellar Book, buying from the marketplace, and posting wines to earn more Vino Coins." title="Unlock Bids and Earn Vino Coins on TresorVino">
                            </div> -->
                        </div>
                    </div>
                    <div class="feature">
                        <div class="feature-info" id="ft-wine-db">
                            <h3 class="feature-title">{{ 'home.feature_3_title' | translate }}</h3>
                            <p class="feature-description">{{ 'home.feature_3_desc' | translate }}</p>
                        </div>
                        <div class="feature-video">
                            <ng-lottie class="d-md-none" [options]="wineMobileOptions"></ng-lottie>
                            <!-- <div class="sticky-container">
                                <ng-lottie class="d-none d-md-block" [options]="wineDeskOptions" width="400"></ng-lottie>
                                <img class="d-none d-md-block" src="../../assets/homepage/wine-database/wine-database-desktop.gif" alt="Detailed wine listing for Mont Redon Châteauneuf-du-Pape, featuring producer information, market price, quantity, and selling options." title="Mont Redon Châteauneuf-du-Pape Wine Listing">
                                <img class="d-md-none" src="../../assets/homepage/wine-database/wine-database-mobile.gif" alt="Detailed wine listing for Mont Redon Châteauneuf-du-Pape, featuring producer information, market price, quantity, and selling options." title="Mont Redon Châteauneuf-du-Pape Wine Listing">
                            </div> -->
                        </div>
                    </div>
                    <div class="feature">
                        <div class="feature-info" id="ft-p2p">
                            <h3 class="feature-title">{{ 'home.feature_4_title' | translate }}</h3>
                            <p class="feature-description">{{ 'home.feature_4_desc' | translate }}</p>
                        </div>
                        <div class="feature-video">
                            <ng-lottie class="d-md-none" [options]="p2pMobileOptions"></ng-lottie>
                            <!-- <div class="sticky-container">
                                <ng-lottie class="d-none d-md-block" [options]="p2pDeskOptions" width="400"></ng-lottie>
                                <img class="d-none d-md-block" src="../../assets/homepage/p2p/p2p-desktop.gif" alt="A visual representation of users with different levels and badges, along with wine trading options like ‘Bid’ and ‘Sell’ highlighted below." title="User Levels and Wine Trading Options">
                                <img class="d-md-none" src="../../assets/homepage/p2p/p2p-mobile.gif" alt="A visual representation of users with different levels and badges, along with wine trading options like ‘Bid’ and ‘Sell’ highlighted below." title="User Levels and Wine Trading Options">
                            </div> -->
                        </div>
                    </div>
                    <div class="feature">
                        <div class="feature-info" id="ft-community">
                            <h3 class="feature-title">{{ 'home.feature_5_title' | translate }}</h3>
                            <p class="feature-description">{{ 'home.feature_5_desc' | translate }}</p>
                        </div>
                        <div class="feature-video">
                            <ng-lottie class="d-md-none" [options]="commMobileOptions"></ng-lottie>
                            <!-- <div class="sticky-container">
                                <ng-lottie class="d-none d-md-block" [options]="commDeskOptions" width="400"></ng-lottie>
                                <img class="d-none d-md-block" src="../../assets/homepage/community/global-community-desktop.gif" alt="A private wine community group interface showing members and a discussion post about the best places to learn about wine making." title="Community Group for Wine Enthusiasts in Berlin">
                                <img class="d-md-none" src="../../assets/homepage/community/global-community-mobile.gif" alt="A private wine community group interface showing members and a discussion post about the best places to learn about wine making." title="Community Group for Wine Enthusiasts in Berlin">
                            </div> -->
                        </div>
                    </div>
                    <div class="feature asset-class">
                        <div class="feature-info" id="ft-asset">
                            <h3 class="feature-title">{{ 'home.feature_6_title' | translate }}</h3>
                            <p class="feature-description">{{ 'home.feature_6_desc' | translate }}</p>
                        </div>
                        <div class="feature-video">
                            <ng-lottie class="d-md-none" [options]="assetMobileOptions"></ng-lottie>
                            <!-- <div class="sticky-container">
                                <ng-lottie class="d-none d-md-block" [options]="assetDeskOptions" width="400"></ng-lottie>
                                <img class="d-none d-md-block" src="../../assets/homepage/asset-class/asset-class-desktop.gif" alt="Screenshot of a Digital Cellar Book interface showing detailed wine profiles, prices, and purchase history." title="Digital Cellar Book for Managing Wine Collections">
                                <img class="d-md-none" src="../../assets/homepage/asset-class/asset-class-mobile.gif" alt="Screenshot of a Digital Cellar Book interface showing detailed wine profiles, prices, and purchase history." title="Digital Cellar Book for Managing Wine Collections">
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="desktop-lottie-section d-none d-md-block">
                    <div class="feature-video" id="ft-dashboard" [ngClass]="{'show-lottie': currentSection === 'ft-dashboard'}">
                        <div class="sticky-container">
                            <ng-lottie class="d-none d-md-block" [options]="dashboardDeskOptions" width="400"></ng-lottie>
                        </div>
                    </div>
                    <div class="feature-video" id="ft-vino" [ngClass]="{'show-lottie': currentSection === 'ft-vino'}">
                        <div class="sticky-container">
                            <ng-lottie class="d-none d-md-block" [options]="vinoDeskOptions" width="400"></ng-lottie>
                        </div>
                    </div>
                    <div class="feature-video" id="ft-wine-db" [ngClass]="{'show-lottie': currentSection === 'ft-wine-db'}">
                        <div class="sticky-container">
                            <ng-lottie class="d-none d-md-block" [options]="wineDeskOptions" width="400"></ng-lottie>
                        </div>
                    </div>
                    <div class="feature-video" id="ft-p2p" [ngClass]="{'show-lottie': currentSection === 'ft-p2p'}">
                        <div class="sticky-container">
                            <ng-lottie class="d-none d-md-block" [options]="p2pDeskOptions" width="400"></ng-lottie>
                        </div>
                    </div>
                    <div class="feature-video" id="ft-community" [ngClass]="{'show-lottie': currentSection === 'ft-community'}">
                        <div class="sticky-container">
                            <ng-lottie class="d-none d-md-block" [options]="commDeskOptions" width="400"></ng-lottie>
                        </div>
                    </div>
                    <div class="feature-video" id="ft-asset" [ngClass]="{'show-lottie': currentSection === 'ft-asset'}">
                        <div class="sticky-container">
                            <ng-lottie class="d-none d-md-block" [options]="assetDeskOptions" width="400"></ng-lottie>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="section-six-half">
        <span class="curly-banner">
            <img src="../../assets/homepage/images/vino_coin_bg.png" alt="Carly background" srcset="" class="w-100">
        </span>
        <div class="d-flex content w-100">
            <span>
                <img src="../../assets/homepage/images/vino_coins_mountain.png" alt="VC Mountain" srcset="">
            </span>
            <div>
                <p>{{ 'home.vc_earn_title' | translate }}</p>
                <p>{{ 'home.vc_earn_text' | translate }}</p>
                <button type="button" class="btn tr-btn-primary" routerLink="/registration">{{ 'home.banner_sign_up' | translate }}</button>
            </div>
        </div>
    </section>
    <section class="section-seven">
        <div class="container read-more">
            <h4 class="heading primary-color text-center">{{ 'home.check_out' | translate }}</h4>
            <carousel [itemsPerSlide]="itemsPerSlide" [showIndicators]="false">
                <slide *ngFor="let article of wineArticles; let i = index;" [ngClass]="{'single-slide': wineArticles.length == 1}">
                    <div class="article-slide">
                        <div class="card-background">
                            <div class="article-image">
                                <img [src]="article.imagePath">
                            </div>
                            <div class="article-details">
                                <span class="article-name primary-color">{{ article.title }}</span>
                                <span class="article-description">{{ article.description }}</span>
                                <div class="button-container">
                                    <button type="button" class="btn tr-btn-primary" [routerLink]="['/blogs', i]">{{ 'home.read' | translate }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </slide>
            </carousel>
            <div class="button-container text-center">
                <button type="button" class="btn tr-btn-primary" routerLink="/blogs">{{ 'home.view_more' | translate }}</button>
            </div>
        </div>
    </section>
    <section class="section-eight scroll-section" id="faq">
        <div class="faq-wave-banner"></div>
        <div class="faq-section">
            <div class="container">
                <h2 class="heading">{{ 'home.any_question' | translate }} <i class="secondary-color">{{ 'home.we_got_you' | translate }}</i></h2>
                <div class="faq" *ngFor="let faq of mainFaqList; let i = index;">
                    <div class="question">
                        <div class="text">{{ faq.question }}</div>
                        <div class="icon" (click)="openAccordion(i)">
                            <mat-icon *ngIf="openFaqIndex !== i">add_2</mat-icon>
                            <mat-icon *ngIf="openFaqIndex === i">remove</mat-icon>
                        </div>
                    </div>
                    <div class="answer secondary-color" *ngIf="openFaqIndex === i" [innerHTML]="faq.answer"></div>
                </div>
                <div class="button-container text-center">
                    <button type="button" class="btn tr-btn-primary" routerLink="/faqs">{{ 'home.view_more' | translate }}</button>
                </div>
            </div>
        </div>
    </section>
</div>
<app-info-overlay [infoText]="infoText" (onClose)="onInfoOverlayClose()" *ngIf="showInfoOverlay" style="color:black;"></app-info-overlay>
<app-carousel-overlay [imageList]="carouselImages" (onClose)="hideCarouselOverlay()" *ngIf="showCarouselOverlay"></app-carousel-overlay>